var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_2491)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(90 36 0)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2748 22.8886C19.1543 22.0261 19.4926 20.8317 19.2896 19.8365L19.8985 19.2393C19.9662 19.3057 20.778 20.1682 20.7104 20.1019C20.5751 21.2299 20.981 22.2251 21.7252 22.955C23.1459 24.3483 25.5137 24.3483 26.9345 22.955C28.3552 21.5616 28.3552 19.2393 26.9345 17.846C26.1226 17.0497 24.9725 16.6516 23.6195 16.917L22.8753 16.1872L23.5518 15.4573C25.3108 13.6659 26.2579 11.1445 26.055 8.62319C26.055 8.35778 25.852 8.15873 25.649 8.02603C25.3784 7.95968 25.1078 8.02603 24.9049 8.15873L19.8309 13.135L14.8245 8.22508C14.6892 8.02603 14.4186 7.95968 14.148 8.09238C13.8774 8.15873 13.7421 8.35778 13.6744 8.62319C13.4715 11.1445 14.351 13.5995 16.1776 15.4573L16.8541 16.1872L16.1776 16.8507C15.2304 16.6516 13.945 16.917 13.0655 17.7796C11.6448 19.173 11.6448 21.4289 13.0655 22.8886C14.4863 24.282 16.8541 24.282 18.2748 22.8886ZM25.5137 19.2393C26.1903 19.9028 26.1226 20.8981 25.5137 21.4953C24.8372 22.1588 23.8224 22.0924 23.2135 21.4953C22.6047 20.8981 22.6047 19.8365 23.2135 19.2393C23.8901 18.5758 24.9049 18.5758 25.5137 19.2393ZM20.5074 15.7227C20.6427 15.8554 20.778 16.0545 20.778 16.3199C20.778 16.7843 20.4397 17.1824 19.8985 17.1824C19.3573 17.1824 19.019 16.7843 19.019 16.3199C19.019 16.1208 19.0867 15.8554 19.2896 15.7227C19.6279 15.4573 20.1015 15.391 20.5074 15.7227ZM14.4863 19.2393C15.1628 18.5758 16.1776 18.6422 16.7865 19.2393C17.463 19.9028 17.3953 20.8981 16.7865 21.4953C16.1099 22.1588 15.0951 22.0924 14.4863 21.4953C13.8774 20.8981 13.8774 19.8365 14.4863 19.2393Z",
    fill: "#C7C7C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_2491",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2491"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2491",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutIcon);
export default __webpack_public_path__ + "static/media/cut-icon.dd00eaa89d474e8792d47705ad57daa6.svg";
export { ForwardRef as ReactComponent };